// src/components/common/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resetea el scroll del window y de cualquier contenedor interno marcado con
// data-scroll-root al cambiar de ruta. Algunos dashboards (Bronze, Company)
// envuelven sus <Routes> internas en un div con overflow-y-auto y altura fija,
// así que el scroll vive en ese div, no en window — sin esto, al ir de
// /bronze-member/news (scrolleado abajo) a /bronze-member/news/:id la nota
// abre con el scroll heredado del feed.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll('[data-scroll-root]').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;